import React, { FC } from 'react';
import MuiDivider, { DividerProps } from '@material-ui/core/Divider';
import useStyles from './style';

const Divider: FC<DividerProps> = (props) => {
  const { root } = useStyles(props);

  return (
    <MuiDivider
      {...props}
      className={root}
    />
  );
};

export default Divider;
